import { render } from "./multiUploadComponent.vue?vue&type=template&id=6b810c57"
import script from "./multiUploadComponent.vue?vue&type=script&lang=js"
export * from "./multiUploadComponent.vue?vue&type=script&lang=js"

import "./multiUploadComponent.vue?vue&type=style&index=0&id=6b810c57&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__